export default "__VITE_ASSET__TImWnwTU__"